export class App {
	public id: string;
	public name: string;

	constructor(app?: App) {
		Object.assign(this, app);
	}
}
